import { AxiosRequestConfig } from "axios";
import { ApiBase } from "../apibase";
import { apiConfig, API_ENDPOINT } from "./td.config";
import { INode, ISearchNode } from "@/shared/models/node.model";
import { IContainer } from "@/shared/models/container.model";

/* eslint-disable */
class TDApi extends ApiBase {
  constructor(config: AxiosRequestConfig) {
    // NEVER FORGET THE SUPER
    super(config);

    this.getTree.bind(this);
    this.getConditions.bind(this);
    this.getNodeByUrl.bind(this);
    this.getSelectableNodeById.bind(this);
    this.searchNodes.bind(this);
    this.getConditionsForExport.bind(this);
  }


   /**
   * Get tree
   * @returns {Promise<INode[]>}
   */
    public async getTree(): Promise<INode[]> {
      const response = await this.get<INode[]>(`${API_ENDPOINT}/tree`);
      return response.data;
    }

   /**
   * Get conditions for a node
   * @param
   * @returns {Promise<IContainer>}
   */
  public async getConditions(nodeId: number): Promise<IContainer> {
    const response = await this.get<any>(`${API_ENDPOINT}/conditions/${nodeId}`);
    return response.data;
  }

   /**
   * Get a node from url
   * @param
   * @returns {Promise<INode>}
   */
    public async getNodeByUrl(url: string): Promise<INode> {
      const response = await this.get<any>(`${API_ENDPOINT}/node/?url=${url}`);
      return response.data;
    }

   /**
   * Get a node from level id
   * @param
   * @returns {Promise<INode>}
   */
     public async getSelectableNodeById(levelId: string): Promise<INode> {
      const response = await this.get<any>(`${API_ENDPOINT}/selectable-node/?levelid=${levelId}`);
      return response.data;
    }

   /**
   * Search in nodes
   * @param
   * @returns {Promise<ISearchNode[]>}
   */
     public async searchNodes(phrase: string): Promise<ISearchNode[]> {
      const response = await this.get<any>(`${API_ENDPOINT}/search-nodes/?phrase=${phrase}`);
      return response.data;
    }

  /**
   * Get conditions for one or many nodes
   * @param
   * @returns {Promise<IContainer[]>}
   */
  public async getConditionsForExport(nodes : number[]): Promise<IContainer[]> {
    const response = await this.post<any>(`${API_ENDPOINT}/conditions-by-nodes`, nodes);
    return response.data;
  }
}
export const tdApi = new TDApi(apiConfig);
